import React, { useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { images } from '../../assets/images';
import { routes } from '../../routes';
import ContentController from '../../apis/controller/content.controller';
import { renderImage } from '../../Components/helper/image';

function Technologies() {
    const [technologies, setTechnologies] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getTechnologies();
        window.scrollTo(0, 0);
    }, []);

    const getTechnologies = async () => {
        setLoader(true);
        let res = await new ContentController().technolgy();
        if (res && res.status) {
            setTechnologies(res.technologies);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };
    return (
        <>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            {technologies && <div className="technologies_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="technologies_in">
                                {technologies && technologies.mobility ? <div className="head_set">
                                    <h3>
                                        {technologies.mobility.title}
                                    </h3>
                                    <p>
                                        {technologies.mobility.description}
                                    </p>
                                </div> : null}
                                <div className="technologies_list">
                                    {technologies.mobility.image.length > 0 && <div className="list_area">
                                        {technologies.mobility.image.map((item, index) => (
                                            <div key={index} className="list_block">
                                                <div className="list_img_set">
                                                    <img src={renderImage(item, 'medium')} alt="../" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="technologies_in">
                                {technologies && technologies.jsFrontend ? <div className="head_set">
                                    <h3>
                                        {technologies.jsFrontend.title}
                                    </h3>
                                    <p>
                                        {technologies.jsFrontend.description}
                                    </p>
                                </div> : null}
                                <div className="technologies_list">
                                {technologies.jsFrontend.image.length > 0 && <div className="list_area">
                                        {technologies.jsFrontend.image.map((item, index) => (
                                            <div key={index} className="list_block">
                                                <div className="list_img_set">
                                                    <img src={renderImage(item, 'medium')} alt="../" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="technologies_in">
                                {technologies && technologies.backend ? <div className="head_set">
                                    <h3>
                                        {technologies.backend.title}
                                    </h3>
                                    <p>
                                        {technologies.backend.description}
                                    </p>
                                </div> : null}
                                <div className="technologies_list">
                                {technologies.backend.image.length > 0 && <div className="list_area">
                                        {technologies.backend.image.map((item, index) => (
                                            <div key={index} className="list_block">
                                                <div className="list_img_set">
                                                    <img src={renderImage(item, 'medium')} alt="../" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="technologies_in">
                                {technologies && technologies.eCommerce ? <div className="head_set">
                                    <h3>
                                        {technologies.eCommerce.title}
                                    </h3>
                                    <p>
                                        {technologies.eCommerce.description}
                                    </p>
                                </div> : null}
                                <div className="technologies_list">
                                {technologies.eCommerce.image.length > 0 && <div className="list_area">
                                        {technologies.eCommerce.image.map((item, index) => (
                                            <div key={index} className="list_block">
                                                <div className="list_img_set">
                                                    <img src={renderImage(item, 'medium')} alt="../" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
}

export default Technologies;